// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Belt_Option from "@rescript/runtime/lib/es6/Belt_Option.js";
import * as Stdlib_Dict from "@rescript/runtime/lib/es6/Stdlib_Dict.js";
import * as Stdlib_JSON from "@rescript/runtime/lib/es6/Stdlib_JSON.js";
import * as RescriptRelay from "rescript-relay/src/RescriptRelay.re.mjs";
import * as RelayRuntime from "relay-runtime";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as Client from "react-dom/client";
import * as RelayRouter__Bindings from "./RelayRouter__Bindings.re.mjs";

let streamedPreCache = {};

let replaySubjects = {};

function cleanupId(id) {
  console.log("[debug] Cleaning up id \"" + id + "\"");
  Stdlib_Dict.$$delete(replaySubjects, id);
}

function handleIncomingStreamedDataEntry(streamedEntry) {
  console.log("[debug] Got streamed entry: " + Belt_Option.getWithDefault(JSON.stringify(streamedEntry), "-"));
  let replaySubject = replaySubjects[streamedEntry.id];
  if (replaySubject !== undefined) {
    let replaySubject$1 = Primitive_option.valFromOption(replaySubject);
    RelayRouter__Bindings.RelayReplaySubject.applyPayload(replaySubject$1, streamedEntry);
    if (Belt_Option.getWithDefault(streamedEntry.final, false)) {
      console.log("[debug] completing replay subject with id " + streamedEntry.id);
      replaySubject$1.complete();
      return;
    } else {
      return;
    }
  }
  replaySubjects[streamedEntry.id] = new RelayRuntime.ReplaySubject();
  let data = streamedPreCache[streamedEntry.id];
  if (data !== undefined) {
    data.push(streamedEntry);
  } else {
    streamedPreCache[streamedEntry.id] = [streamedEntry];
  }
}

function bootOnClient(target, render) {
  let boot = () => {
    Belt_Array.forEach(Belt_Option.getWithDefault(Primitive_option.fromNullable(window.__RELAY_DATA), []), handleIncomingStreamedDataEntry);
    window.__RELAY_DATA = {
      push: streamedEntry => {
        console.log("[debug] Got stream response when client was ready: ", streamedEntry);
        handleIncomingStreamedDataEntry(streamedEntry);
      }
    };
    console.log("[debug] Booting because stream said so...");
    Client.hydrateRoot(target, render());
  };
  window.__BOOT = boot;
  if (Belt_Option.getWithDefault(Primitive_option.fromNullable(window.__READY_TO_BOOT), false)) {
    boot();
  }
  window.__STREAM_COMPLETE = () => {
    console.log("[debug] completing stream: " + Object.keys(replaySubjects).join(", "));
    Belt_Array.forEach(Object.keys(replaySubjects), key => Stdlib_Dict.$$delete(replaySubjects, key));
  };
}

function subscribeToReplaySubject(replaySubject, sink) {
  return replaySubject.subscribe({
    next: data => sink.next(data),
    error: e => sink.error(e),
    complete: () => sink.complete()
  });
}

function applyPreCacheData(replaySubject, id) {
  let preCacheData = streamedPreCache[id];
  if (preCacheData !== undefined) {
    Belt_Array.forEach(preCacheData, data => {
      let response = data.response;
      if (response === undefined) {
        return;
      }
      let final = data.final;
      if (final !== undefined) {
        replaySubject.next(response);
        if (final) {
          replaySubject.complete();
          return cleanupId(id);
        } else {
          return;
        }
      }
    });
    return Stdlib_Dict.$$delete(streamedPreCache, id);
  }
}

function makeIdentifier(operation, variables) {
  return operation.name + Belt_Option.getWithDefault(JSON.stringify(variables), "{}");
}

function makeClientFetchFunction(fetch) {
  return (operation, variables, _cacheConfig, _uploads) => RelayRuntime.Observable.create(sink => {
    let id = makeIdentifier(operation, variables);
    let replaySubject = replaySubjects[id];
    if (replaySubject !== undefined) {
      let replaySubject$1 = Primitive_option.valFromOption(replaySubject);
      console.log("[debug] request " + id + " had ReplaySubject");
      let subscription = subscribeToReplaySubject(replaySubject$1, sink);
      let cleanupSubscription = replaySubject$1.subscribe({
        complete: () => cleanupId(id)
      });
      applyPreCacheData(replaySubject$1, id);
      return {
        unsubscribe: () => {
          subscription.unsubscribe();
          cleanupSubscription.unsubscribe();
        },
        closed: false
      };
    }
    console.log("[debug] request " + id + " did not have ReplaySubject");
    return fetch(sink, operation, variables, _cacheConfig, _uploads);
  });
}

function makeServerFetchFunction(onQuery, fetch) {
  return (operation, variables, cacheConfig, uploads) => {
    let queryId = makeIdentifier(operation, variables);
    onQuery(queryId, undefined, false);
    let observable = RelayRuntime.Observable.create(sink => fetch(sink, operation, variables, cacheConfig, uploads));
    return observable.do({
      next: payload => {
        let obj = Stdlib_JSON.Decode.object(payload);
        let tmp;
        if (obj !== undefined) {
          let hasNext = obj["hasNext"];
          if (hasNext !== undefined) {
            let match = Stdlib_JSON.Decode.bool(hasNext);
            tmp = match !== undefined ? !match : true;
          } else {
            tmp = true;
          }
        } else {
          tmp = true;
        }
        onQuery(queryId, Primitive_option.some(payload), Primitive_option.some(tmp));
      }
    });
  };
}

export {
  bootOnClient,
  makeIdentifier,
  makeClientFetchFunction,
  makeServerFetchFunction,
}
/* RescriptRelay Not a pure module */
